import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { closeMenuItemAndGoToMenu } from 'menus/actions/menuItem';
import MenuItemDetail from 'menus/containers/MenuItemDetail';
import Modal from 'base/ui_components/Modal';
import { WHITE } from 'base/constants/colors';
import { getMenuItemImage, getMenuItem } from 'menus/reducers/menuItemsDetail';
import withGoogleLibraryLoaded from 'base/hoc/withGoogleLibraryLoaded';

class MenuItemDetailModal extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    menuItemImage: PropTypes.string
  };

  render() {
    const { dispatch, menuItemImage } = this.props;
    const closeButtonColor = menuItemImage ? WHITE : '';
    return (
      <Modal
        closeButtonDataTestId="menu-item-detail-close"
        closeButtonColor={closeButtonColor}
        onClose={() => dispatch(closeMenuItemAndGoToMenu())}
      >
        <MenuItemDetail />
      </Modal>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { menuItemSlug } = ownProps.match.params;

  const menuItem = getMenuItem(state.menuItemsDetail, menuItemSlug);
  return {
    menuItemImage: getMenuItemImage(menuItem)
  };
};
export default withRouter(
  withGoogleLibraryLoaded(connect(mapStateToProps)(MenuItemDetailModal))
);
